import { useMemo } from "react";
import styled from "styled-components/macro";
import { media } from "../../../utils";

const VARIANT_COLORS = {
  neutral: () => ``,
  primary: (theme) => `
    background-color: ${theme.color.brandPrimary.light} !important;
    color: ${theme.color.neutral["08"]};
  `,
  secondary: (theme) => ({
    "background-color": theme.color.brandSecondary.medium,
    color: theme.color.neutral["08"],
  }),
  tertiary: (theme) => ({
    "background-color": theme.color.brandTertiary.medium,
    color: theme.color.neutral["08"],
  }),
  quaternary: (theme) => ({
    "background-color": "#500778",
    color: theme.color.neutral["08"],
  }),
};

const DEFAULT_PADDING = {
  DEFAULT: "40px 16px",
  MOBILE: "40px 0px",
  DESKTOP: "60px 0",
  SLIM: {
    DEFAULT: "16px",
    MOBILE: "16px 0",
    DESKTOP: "20px 0",
  },
};

export const SectionContentStyled = styled.div(({ spaceSlim }) => {
  const spaces = spaceSlim ? DEFAULT_PADDING.SLIM : DEFAULT_PADDING;

  return {
    width: "100%",
    margin: "0 auto",
    padding: spaces.DEFAULT,

    [media.sm()]: {
      maxWidth: "540px",
      padding: spaces.MOBILE,
    },

    [media.md()]: {
      maxWidth: "720px",
    },

    [media.lg()]: {
      maxWidth: "960px",
      padding: spaces.DESKTOP,
    },

    [media.xl()]: {
      maxWidth: "1218px",
    },
  };
});

export default styled.section`
  position: relative;
  &.Section__Background {
    ${(props) => {
      const { variant = "neutral", theme } = props;
      return useMemo(() => VARIANT_COLORS[variant](theme), [theme, variant]);
    }}
  }
`;
